export default{
	global:{
		chinese:"中文",
		home:{
			companyProfile:"公司简介",
			companyProfile1:"天津赢事达是一家专业生产热转印色带的涂布厂家，成立于1992年，其前身是赢事达油墨厂。\n1997年成功生产热转印色带，正式更名为天津赢事达办公用品厂。\n工厂位于滨海机场附近的华明工业园，占地面积5000多平方米。\n赢事达拥有超过32年热转印色带的生产经验和历史，年生产能力达4.5亿平方米。",
			companyProfile2:"我们是国内资历较老、质量稳定、产销规模大、性价比高的热转印色带涂布厂。\n牛宝兴（CEO）致力于热转印行业色带的研发。参与热转印行标的制定。\n天津赢事达亦是国内一家采用热升华技术的涂布厂家。",
			kh1:"质量第一",
			kh2:"成就客户",
			kh3:"科技创新",
			kh4:"团结拼搏",
			companyHonors:"企业资质",
			companyProducts:"公司产品",
			companyGrid:"质量控制中心",
			// grid1:"成立于2002年，该中心下属部门有研发部门，实验室，和品管部门，集研发，测试和品控于一体，是我司一个全功能的开发部门。"
			// grid1:"赢事达营销服务网络健全完善，在天津市、北京市、河北省、河南省、浙江省、广东省、山东省、云南省、福建省、湖南省、湖北省、美国、迪拜、墨西哥、泰国、毛里求斯、巴基斯坦、伊朗、越南、格伦比亚等大中城市设有销售机构。产品销售覆盖全国，并远销70多个国家和地区，外贸出口占总收入的近65%。"
		},
		product:{
			productInformation:"产品信息",
			productWidth:"产品长度",
			productLength:"产品宽度",
			productCarbonSurface:"产品碳面",
			productAxis:"产品轴",
			productColor:"产品颜色",
			productCustomization:"产品定制",
			productJZ:"推荐介质",
			detail:"详情",
		},
		suppor:{
			clickPreview:"点击预览",
			commonProblem:"常见问题",
			dataDownload:"资料下载",
			anomalyAnalysis:"异常分析",
			troubleshootingAndSolutions:"排查、解决方案",
			colorPage:"产品彩页",
		}
	}
}